module.exports = __webpack_public_path__ + "img/full.a46361dc.png";